export class TipoFinanziamento{
    id:number;
    tipoFinanziamento:string;    
}